//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent } from "@vue/composition-api";
import { getApplicationSyncErrorMessage, isErrorWithFilogixDetails } from "@Broker/js/custom/utils";
import { useI18n } from "vue-i18n-composable";
export default defineComponent({
  name: "ERDSyncError",
  props: {
    status: {
      type: Object,
      required: true
    },
    expert: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasUserErrors() {
      return !!this.status.userErrors;
    },
    genericMessage() {
      const {
        t
      } = useI18n();
      const basePath = getApplicationSyncErrorMessage(this.status, true, this.expert);
      return isErrorWithFilogixDetails(this.status) && basePath ? t(`${basePath}_SHORT`) : t(`${basePath}`);
    }
  },
  methods: {}
});